import React from 'react';
import passwordStrength from 'zxcvbn';

import { styled } from '@mui/material/styles';
import ArrowRightIcon from '@mui/icons-material/ArrowRight';
import List from '@mui/material/List';
import ListItemText from '@mui/material/ListItemText';
import ListItemIcon from '@mui/material/ListItemIcon';
import MuiTypography from '@mui/material/Typography';

import ListItem from 'components/v2/FormElements/ListItem';

const scoreLabels = ['Weak', 'Average', 'Good', 'Strong', 'Very Strong'];

const scoreColorMap = {
  tooshort: 'red',
  weak: 'orange',
  average: '#555',
  good: 'green',
  strong: 'green',
  verystrong: 'green',
};

const PasswordHint = styled('div')({
  top: '1.25rem',
  right: 75,
  position: 'absolute',
  zIndex: 1,
});

const ScoreText = styled(MuiTypography)(({ scoreClass }) => ({
  color: scoreColorMap[scoreClass] || 'green',
}));

const helpItems = [
  'Longer than 8 characters',
  'Unique to Compliance',
  'Hard for a stranger to guess',
];

const StyledListItemIcon = styled(ListItemIcon)({
  minWidth: 0,
});

const FlexListItem = styled(ListItem)({
  display: 'flex',
});

const renderHelpListItem = (item) => {
  return (
    <FlexListItem dense key={`rule-${item}`}>
      <StyledListItemIcon>
        <ArrowRightIcon />
      </StyledListItemIcon>
      <ListItemText secondary={item} />
    </FlexListItem>
  );
};

const Index = ({ password, password_confirmation }) => {
  const [score, setScore] = React.useState();

  const passwordsCheck = () => {
    if (password && password.length <= 8) {
      return { password: 'password must be longer than 8 characters' };
    }

    if (score < 2) {
      return { password: 'password must be above average strength.' };
    }

    if (password && password !== password_confirmation) {
      return { password_confirmation: 'passwords must match' };
    }
  };

  const passwordHelperText = () => {
    if (password && password.length <= 8) {
      return 'Too Short';
    }

    return scoreLabels[score];
  };

  const getScoreClass = () => {
    const helperText = passwordHelperText();
    return helperText && helperText.toLowerCase().replace(/\s+/g, '');
  };

  const PasswordHelper = () => {
    return (
      <PasswordHint>
        <ScoreText variant="caption" scoreClass={getScoreClass()}>
          {passwordHelperText()}
        </ScoreText>
      </PasswordHint>
    );
  };

  const PasswordRules = () => {
    return (
      <List>
        <ListItem>
          <ListItemText primary="Your password should be:" />
        </ListItem>
        {helpItems.map(renderHelpListItem)}
      </List>
    );
  };

  React.useEffect(() => {
    if (password && password.length > 8) {
      setScore(passwordStrength(password).score);
    } else {
      setScore(null);
    }
  }, [password]);

  return {
    PasswordHelper,
    PasswordRules,
    passwordsCheck,
  };
};

export default Index;
